/**
 * Manifest of all the MFs active within X4A. Host app will search
 * for remotes of each MF here to bootstrap X4A together.
 * Keep this list up to date (add new MF and remove archived MF)
 * */
export const mfNamesProd = [
  'account_mf',
  'bid_mf',
  'bidregistration_mf',
  'cart_mf',
  'cep_returnsandclaims_mf',
  'checkout_mf',
  'cloudreports_mf',
  'cms_mf',
  'configurationmanager_mf',
  'credit_mf',
  'customize_report_mf',
  'dashboard_mf',
  'empty_mf',
  'financecalculator_mf',
  'insight_mf',
  'invoice_mf',
  'loyaltymanagement_mf',
  'ost_mf',
  'partneractivation_mf',
  'payment_mf',
  'product_mf',
  'quotemgmt_mf',
  'renewals_mf',
  'resellermanagement_mf',
  'resellermarketplace_mf',
  'return_mf',
  'sandbox_mf',
  'subscriptions_mf',
  'support_x4c_mf',
  'voucher_mf',
  'vri_mf',
  'xi_appstore_mf',
  'xi_workato_mf',
  'xi_psaintegration_mf',
  'xvs_renewalsengine_mf',
];

const mfNamesBeta = [...mfNamesProd];

const mfNamesStg = [...mfNamesBeta, 'global_auditlog_mf'];

const envMappings: Record<
  'default' | 'production' | 'productionbeta',
  string[]
> = {
  default: mfNamesStg,
  production: mfNamesProd,
  productionbeta: mfNamesBeta,
};

const envKey = (process.env.NODE_ENV ?? 'staging') as keyof typeof envMappings;
const mfNames = envMappings[envKey] || envMappings.default;

export { mfNames };
